import React from "react";
import Tabs from "react-bootstrap/lib/Tabs";
import Tab from "react-bootstrap/lib/Tab";

import Prayers from "./Prayers";
import Meditation from "./Meditation";

const PrayerAndMeditationTab = () => (
  <div>
    <Tabs defaultActiveKey={1} id="prayer_meds_tab">
      <Tab eventKey={1} title="Prayers">
        <Prayers />
      </Tab>
      <Tab eventKey={2} title="Meditation">
        <Meditation />
      </Tab>
    </Tabs>
  </div>
);

export default PrayerAndMeditationTab;



// WEBPACK FOOTER //
// ./src/components/PrayerAndMeditationTab.js